import { AnalyticsBrowser as SegmentBrowser } from "@segment/analytics-next";

export const segment = SegmentBrowser.load({ writeKey: import.meta.env.VITE_SEGMENT_KEY });
